import { CheckboxPartialIcon, CheckboxFilledIcon, CheckboxOutlineIcon } from '../../icons/index.js';
import { jsx } from 'react/jsx-runtime';

const MuiCheckboxOverrides = {
  MuiCheckbox: {
    styleOverrides: {
      root: _ref => {
        let {
          theme
        } = _ref;
        return {
          color: theme.palette.text.disabled
        };
      }
    },
    defaultProps: {
      icon: /*#__PURE__*/jsx(CheckboxOutlineIcon, {}),
      checkedIcon: /*#__PURE__*/jsx(CheckboxFilledIcon, {}),
      indeterminateIcon: /*#__PURE__*/jsx(CheckboxPartialIcon, {}),
      size: 'small'
    }
  }
};

export { MuiCheckboxOverrides };
